module.exports = __webpack_public_path__ + "static/media/2-2.94ae65cd.mp3";